import angular from 'angular';

import raPaginationComponent from './ra-pagination-component';

const pagination = angular.module('ra-pagination', []);
pagination.component('raPagination', raPaginationComponent);

export default pagination.name;
